import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import ReceptionsList from './components/ReceptionsList';
import ReceptionDetail from './components/ReceptionDetail';
import Login from './components/Login';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;
};

const NavBar = () => {
  const { user, logout } = useAuth();
  if (!user) return null;

  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="navbar-brand">Registro de Ingresos</Link>
        <div className="navbar-nav" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <Link to="/" className="nav-link">Ingresos</Link>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px' }}>
              {user.username} {user.branch_name ? `(${user.branch_name})` : ''}
            </span>
            <button
              onClick={logout}
              className="btn btn-danger"
              style={{ padding: '4px 10px', fontSize: '12px' }}
            >
              Salir
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <NavBar />
          <div className="container">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={
                <RequireAuth>
                  <ReceptionsList />
                </RequireAuth>
              } />
              <Route path="/reception/:id" element={
                <RequireAuth>
                  <ReceptionDetail />
                </RequireAuth>
              } />
            </Routes>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
